import React, { useState } from "react";
import { ShieldSecurity } from "iconsax-react";

import MobileLayout from "../../components/MobileLayout";
import {
  SettingsCard,
  SettingsSection,
  SettingsSectionTitle,
  SettingsToggleItem,
} from "../../shared/components/SettingsMenuItem";
import {
  Main,
  SectionHeader,
  SectionHint,
  SectionTitle,
} from "../Register/styles";
import { fontSizes, lineHeights } from "../../shared/styles/typography";

const PRIVACY_STORAGE_KEY = "bilingua_privacy_prefs";

type PrivacyPrefs = {
  analytics: boolean;
  pushNotifications: boolean;
  personalizedAds: boolean;
};

function readPrefs(): PrivacyPrefs {
  try {
    const raw = localStorage.getItem(PRIVACY_STORAGE_KEY);
    if (raw) return JSON.parse(raw) as PrivacyPrefs;
  } catch {
    /* ignore */
  }
  return {
    analytics: true,
    pushNotifications: true,
    personalizedAds: false,
  };
}

function savePrefs(prefs: PrivacyPrefs) {
  localStorage.setItem(PRIVACY_STORAGE_KEY, JSON.stringify(prefs));
}

const PrivacyPage: React.FC = () => {
  const [prefs, setPrefs] = useState<PrivacyPrefs>(readPrefs);

  const update = (key: keyof PrivacyPrefs) => {
    setPrefs((prev) => {
      const next = { ...prev, [key]: !prev[key] };
      savePrefs(next);
      return next;
    });
  };

  return (
    <MobileLayout headerTitle="Privacidade" headerType="private">
      <Main style={{ maxWidth: 600 }}>
        <SectionHeader>
          <SectionTitle>Privacidade</SectionTitle>
          <SectionHint>
            Controle como seus dados são usados na plataforma web.
          </SectionHint>
        </SectionHeader>

        <SettingsSection>
          <SettingsSectionTitle>Preferências</SettingsSectionTitle>
          <SettingsCard>
            <SettingsToggleItem
              title="Análise de uso"
              description="Ajuda a melhorar o app com dados anônimos"
              checked={prefs.analytics}
              onToggle={() => update("analytics")}
            />
            <SettingsToggleItem
              title="Notificações"
              description="Receber avisos sobre novidades e atividades"
              checked={prefs.pushNotifications}
              onToggle={() => update("pushNotifications")}
            />
            <SettingsToggleItem
              title="Anúncios personalizados"
              description="Exibir anúncios com base no seu perfil"
              checked={prefs.personalizedAds}
              onToggle={() => update("personalizedAds")}
            />
          </SettingsCard>
        </SettingsSection>

        <SettingsSection>
          <SettingsSectionTitle>Dados da conta</SettingsSectionTitle>
          <SettingsCard>
            <div
              style={{
                padding: "20px 24px",
                display: "flex",
                gap: 16,
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 14,
                  background: "var(--color-surface-secondary)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--color-danger)",
                  flexShrink: 0,
                }}
              >
                <ShieldSecurity size={22} variant="Bold" />
              </div>
              <div>
                <h5
                  style={{
                    margin: 0,
                    fontSize: fontSizes.base,
                    lineHeight: `${lineHeights.base}px`,
                    fontWeight: 600,
                    color: "var(--color-text-title)",
                  }}
                >
                  Excluir conta
                </h5>
                <p
                  style={{
                    margin: "6px 0 0",
                    fontSize: fontSizes.sm,
                    lineHeight: `${lineHeights.sm}px`,
                    color: "var(--color-text-secondary)",
                  }}
                >
                  Para solicitar a exclusão permanente da sua conta e dados,
                  entre em contato pelo{" "}
                  <a href="/apoiar" style={{ color: "var(--color-primary)" }}>
                    suporte
                  </a>
                  . Esse processo requer confirmação de identidade.
                </p>
              </div>
            </div>
          </SettingsCard>
        </SettingsSection>
      </Main>
    </MobileLayout>
  );
};

export default PrivacyPage;
